import { GraphQLError } from 'graphql';

export function hasUnauthorizedError(errors: ReadonlyArray<GraphQLError> | undefined): boolean {
  if (!errors) return false;

  return Boolean(errors.find((error) => error.extensions && error.extensions.classification === 'HTTP_UNAUTHORIZED'));
}
